import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import { useParams } from 'react-router';

import { Translate } from 'react-redux-i18n';

import Loading from '../../components/Loading/Loading';
import loginActions from './LoginActions';
import style from './Login.module.css';

function Home(props) {
  const { token } = useParams();
  const {
    userId,
    password,
    changePassword,
    loading,
    failed,
    success,
    message,
    preventPasswordChange,
    setPassword,
    getRestorePswdApprove
  } = props;

  useEffect(() => {
     getRestorePswdApprove(token);
  }, [getRestorePswdApprove, token]);

  function showErrorMessage() {
    return failed === true && <div className="alert alert-danger">{message}</div>;
  }

  return (
    <div className="row">
      <div className={`col-md-12 mt-4 ${style.Home}`}>
        { loading && <Loading /> }

        <h1><Translate value="auth.restoreTitle"/></h1>
        <div className="col-sm-8 col-sm-offset-2">
          {preventPasswordChange ? showErrorMessage() :
            <form className={`form ${style.jumbotron}`}>
              <h2 style={{marginTop: 0}}><Translate value="auth.changingPswTitle"/></h2>
              { success ? <p><Translate value="auth.changingPswSuccess"/> <a href="/login"><Translate value="auth.goToLogin"/></a></p> :
                <div>

                  <div className="mb-3">
                    <label htmlFor="password" className={style.margin}><Translate value="auth.Password"/></label>
                    <input
                      type="password"
                      className={`form-control ${style.margin}`}
                      id="password"
                      value={password}
                      onChange={changePassword}
                    />
                  </div>

                  { showErrorMessage() }
                  <button
                    className="btn btn-default"
                    onClick={() => setPassword(userId, password, token)}
                  ><Translate value="auth.SetNewPassword"/>
                  </button>
                </div>
              }
            </form>
          }
        </div>
      </div>
    </div>
  );
}

Home.propTypes = {
  userId: PropTypes.string,
  password: PropTypes.string,
  message: PropTypes.string,
  loading: PropTypes.bool,
  success: PropTypes.bool,
  changePassword: PropTypes.func,
  setPassword: PropTypes.func,
  failed: PropTypes.bool,
  preventPasswordChange: PropTypes.bool,
  isRestoring: PropTypes.bool,
  getRestorePswdApprove: PropTypes.func, // Added missing prop type
};

const mapStateToProps = state => ({
  userId: state.login.userId,
  password: state.login.password,
  loading: state.login.loading,
  message: state.login.message,
  failed: state.login.failed,
  success: state.login.success,
  isRestoring: state.login.isRestoring,
  preventPasswordChange: state.login.preventPasswordChange
});

const mapDispatchToProps = {
  getRestorePswdApprove: loginActions.getRestorePswdApprove,
  changePassword: loginActions.changePassword,
  setPassword: loginActions.setPassword
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Home);
